export default "__VITE_ASSET__qATsf_HF__"